var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoreWaysToSaveHouse = function SvgMoreWaysToSaveHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 439 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.998 213.374c-66.32-.875-82.008 34.971-8.532 34.971 73.477 0 134.584-5.985 186.036 4.239 82.626 16.425 218.555-1.936 201.83-24.397-16.726-22.46-102.007-4.416-102.007-4.416L57.998 213.374Z",
    fill: "#99EDBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.836 89.34h-84.524v138.7h84.524V89.34Z",
    fill: "#8CB3DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M405.827 207.35H327.89v20.681h77.937V207.35Z",
    fill: "#D5EAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.292 228.031h-32.508l3.629-138.7h21.727c.974 19.321 4.063 80.324 6.021 118.01.452 8.238.835 15.349 1.131 20.682v.008Z",
    fill: "#566C77",
    opacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M388.956 121.017h-39.304v59.096h39.304v-59.096Z",
    fill: "#D5EAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.086 123.514h-35.84v53.893h35.84v-53.893Z",
    fill: "#1C7CE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M370.441 121.815h-2.158v56.945h2.158v-56.945Z",
    fill: "#D5EAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M388.504 149.095h-38.511v2.038h38.511v-2.038Z",
    fill: "#D5EAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300.221 31.831h42.854l80.643 61.533H328.57L300.221 31.83Z",
    fill: "#053249"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M424.554 91.855h-81.731v4.284h81.731v-4.284Z",
    fill: "#566C77"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.74 59.745V.9h26.661v41.693l-26.66 17.152Z",
    fill: "#053249"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M333.468 94.378H53.08V231.57h280.388V94.379Z",
    fill: "#8CB3DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M359.772 101.94H30.309l6.317-7.744.792-.988 5.238-6.4.792-.988 5.255-6.417.792-.989 5.23-6.4.791-.988 5.256-6.425.792-.98 5.238-6.408.792-.98 5.229-6.426.81-.988 5.237-6.4.792-.988 5.23-6.417.818-.989 5.212-6.4.809-.988 2.34-2.861h202.443l2.323 2.861.792.989 5.195 6.4.792.988 5.194 6.417.792.988 5.195 6.4.791.988 5.195 6.426.792.98 5.194 6.408.792.98 5.195 6.425.792.989 5.194 6.4.792.988 5.195 6.417.792.988 5.194 6.4.792.988 6.265 7.744Z",
    fill: "#053249"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M299.63 27.626H90.922l.81-.989h207.106l.792.989ZM305.616 35.014H84.892l.818-.989h219.114l.792.989Z",
    fill: "#566C77"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M305.616 35.014H84.892l.818-.989h219.114l.792.989ZM311.602 42.42H78.871l.791-.99h231.149l.791.99ZM317.589 49.807H72.823l.81-.988h243.164l.792.988ZM323.575 57.213H66.802l.792-.98h255.189l.792.98ZM329.562 64.6H60.772l.792-.98H328.77l.792.98ZM335.549 72.015H54.725l.792-.989h279.24l.792.989ZM341.535 79.403H48.704l.792-.989h291.247l.792.989ZM347.521 86.808H42.657l.791-.988H346.73l.791.988ZM353.508 94.197H36.628l.791-.989h315.297l.792.989ZM360.286 100.431H28.282v4.371h332.004v-4.371Z",
    fill: "#566C77"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.926 115.892H78.558v87.755h58.368v-87.755Z",
    fill: "#D5EAFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.141 119.595H80.916v80.029h53.225v-80.029Z",
    fill: "#1C7CE5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.421 117.072h-3.202v84.563h3.202v-84.563Z",
    fill: "#D5EAFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.256 157.593H79.063v3.027h57.193v-3.027ZM310.009 115.892h-58.367v87.755h58.367v-87.755Z",
    fill: "#D5EAFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M307.226 119.595h-53.225v80.029h53.225v-80.029Z",
    fill: "#1C7CE5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M282.505 117.072h-3.203v84.563h3.203v-84.563Z",
    fill: "#D5EAFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M309.339 157.593h-57.193v3.027h57.193v-3.027ZM333.468 214.426H53.08v17.143h280.388v-17.143Z",
    fill: "#D5EAFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M238.825 112.198h-83.68v117.689h83.68V112.198Z",
    fill: "#D5EAFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M235.614 115.225H159.87v113.647h75.744V115.225Z",
    fill: "#1A5CA3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M232.49 226.002h-69.331a.495.495 0 0 1-.496-.494V117.522a.5.5 0 0 1 .496-.494h69.331c.279 0 .496.226.496.494v107.986a.5.5 0 0 1-.496.494Zm-68.835-.98h68.348V118.025h-68.339v106.997h-.009Z",
    fill: "#D5EAFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M228.533 133.374h-60.396a.495.495 0 0 1-.496-.494v-10.926c0-.269.227-.495.496-.495h60.396c.278 0 .495.226.495.495v10.926a.5.5 0 0 1-.495.494Zm-59.9-.989h59.404v-9.937h-59.404v9.937ZM228.531 207.862h-60.395v10.926h60.395v-10.926ZM229.88 170.453c-.095 5.636-8.509 5.636-8.605 0 .096-5.637 8.51-5.637 8.605 0Z",
    fill: "#D5EAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#more-ways-to-save-house_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.718 241.839h-87.351c.835-4.691 3.141-9.114 7.039-11.785 5.334-3.676 13.826-2.783 17.133 2.801 2.558-10.726 11.372-19.736 22.048-22.554 10.703-2.844 22.824.624 30.376 8.671 5.848 6.209 8.789 14.481 10.746 22.867h.009Z",
    fill: "#249241"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#more-ways-to-save-house_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.174 236.78h87.352c-.836-4.692-3.141-9.114-7.04-11.785-5.333-3.676-13.826-2.783-17.132 2.801-2.558-10.726-11.373-19.736-22.05-22.554-10.702-2.845-22.822.624-30.375 8.671-5.847 6.209-8.788 14.481-10.746 22.867h-.009Z",
    fill: "#249241"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "more-ways-to-save-house_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(335.367 209.312)",
    d: "M0 0h87.352v32.526H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "more-ways-to-save-house_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 107.526 204.253)",
    d: "M0 0h87.352v32.527H0z"
  })))));
};
export default SvgMoreWaysToSaveHouse;